import { CSVFlowLoad } from 'pages/SmartConnectors/types';
import { SMART_CONNECTOR_LOAD_TYPES } from 'pages/SmartConnectors/constants';
import { TFunction } from 'react-i18next';

export const triggerDisplay = {
  title: 'Trigger',
  color: '#285de4',
  stats: null,
  deletable: true,
  creatable: true,
  triggerType: true,
  prefix: 'trigger',
};

const connectionDisplay = {
  type: 'connection',
  title: 'Connection',
  color: 'var(--color-background-dark)',
  stats: null,
  movable: true,
  creatable: true,
  deletable: true,
  goalType: true,
  prefix: 'step',
  mergeable: false,
};

const uploadDisplay = {
  type: 'upload',
  title: 'Upload',
  color: '#f3a800',
  stats: null,
  movable: true,
  creatable: true,
  deletable: true,
  goalType: true,
  prefix: 'step',
};

export type SmartStepType =
  | 'upload'
  | 'unknown'
  | 'spreadsheet_upload'
  | 'run_smartconnector'
  | 'upload_primary_object'
  | 'upload_related_object'
  | 'connection_initialize_additional_variables'
  | 'connection_run_get_requests';

const steps: Record<SmartStepType, any> = {
  upload: {
    type: 'upload',
    title: 'Upload',
    color: 'var(--color-agentic-workflow-delay-primary)',
    stats: '34 Completed',
    movable: true,
    creatable: true,
    deletable: true,
    CardComponent: 'DelayCard',
    prefix: 'step',
  },
  unknown: {
    type: 'unknown',
    title: 'Unknown',
    color: 'var(--color-background-dark)',
    stats: null,
    deletable: true,
  },
  spreadsheet_upload: {
    ...triggerDisplay,
    type: 'spreadsheet_upload',
    title: (t: TFunction) => t('Connection Trigger'),
    CardComponent: 'TriggerStepSpreadsheetUploadedCard',
  },
  connection_initialize_additional_variables: {
    ...connectionDisplay,
    type: 'connection_initialize_additional_variables',
    title: (t: TFunction) => t('Initialize Additional Variables'),
    CardComponent: 'InitializeAdditionalVariablesCard',
  },
  connection_run_get_requests: {
    ...connectionDisplay,
    type: 'connection_run_get_requests',
    title: (t: TFunction) => t('Run GET Requests'),
    CardComponent: 'RunGetRequestsCard',
  },
  upload_primary_object: {
    ...uploadDisplay,
    type: 'upload_primary_object',
    title: (t: TFunction) => t('Upload Primary Object'),
    CardComponent: 'UploadPrimaryObjectCard',
  },
  upload_related_object: {
    ...uploadDisplay,
    type: 'upload_related_object',
    title: (t: TFunction) => t('Upload Related Object'),
    CardComponent: 'UploadPrimaryObjectCard',
  },
  run_smartconnector: {
    ...uploadDisplay,
    type: 'run_smartconnector',
    title: (t: TFunction) => t('Run SmartConnector'),
    CardComponent: 'RunSmartConnectorCard',
  },
};

export default steps;

export const defaultSmartConnectorTrigger = {
  id: `new.trigger`,
  type: steps.spreadsheet_upload.type,
  details: {
    type: steps.spreadsheet_upload.type,
  },
  order: 0,
  prefix: triggerDisplay.prefix,
};

export const defaultUploadStep = {
  id: `new.upload.primary_object`,
  type: steps.upload_primary_object.type,
  details: {
    type: SMART_CONNECTOR_LOAD_TYPES.csv_load,
  } as CSVFlowLoad,
  order: 0,
  prefix: uploadDisplay.prefix,
};

export const defaultConnectionStep = {
  id: `new.connection.initialize_additional_variables`,
  type: steps.connection_initialize_additional_variables.type,
  details: {},
  order: 0,
  prefix: uploadDisplay.prefix,
};

export const defaultConnectionGetRequestsStep = {
  id: `new.connection.run_get_requests`,
  type: steps.connection_run_get_requests.type,
  details: {},
  order: 0,
  prefix: uploadDisplay.prefix,
};
